import React, { PureComponent, ReactNode } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import styled from "styled-components";

import { IWithMe } from "../../../../../../../hoc/repository/withMe/withMe";
import theme from "../../../../../../../theme";
import { Mapping } from "../../../../../../../types/primitives";
import Hyperlink from "../../../../../../Hyperlink";
import LangPicker from "../../../../../../LangPicker";

import { footerItemsDictionary, IFooterItem } from "./footerItemsDictionary";

const Wrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-basis: auto;
  justify-content: space-around;
  padding: 8px 0;
  border-top: 1px solid ${theme.colors.grey};
`;

const NavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${theme.fontSizes.small};
`;

export interface IProps extends RouteComponentProps, IWithMe {
  closeMenu: () => void;
}

interface IState {
  isOpenLang: boolean;
}

class AppContentMenuFooter extends PureComponent<
  IProps & { alts: Mapping },
  IState
> {
  public state: IState = {
    isOpenLang: false,
  };

  public render(): ReactNode {
    const { closeMenu, me } = this.props;
    const isAuthenticated = !!me;

    return (
      <NavWrapper>
        <Wrapper>
          {footerItemsDictionary.map(
            (item: IFooterItem, index: number): ReactNode => {
              if (item.onClick && item.getTarget!()) {
                return (
                  <Hyperlink
                    to={item.getTarget!(isAuthenticated)}
                    key={`link-${index}`}
                  >
                    <ItemWrapper
                      key={item.getText!()}
                      onClick={(e: React.MouseEvent): void => {
                        item.onClick!(e, { closeMenu });
                      }}
                    >
                      <>{item.renderIcon()}</>
                      <Text>{item.getText(isAuthenticated)}</Text>
                    </ItemWrapper>
                  </Hyperlink>
                );
              } else {
                return null;
              }
            }
          )}
          <LangPicker />
        </Wrapper>
      </NavWrapper>
    );
  }
}

export default connect((state: { url: Mapping }) => {
  return {
    alts: (state.url || {}).alts || {},
  };
})(AppContentMenuFooter);
